export default __webpack_public_path__ + "static/media/img_14.f8bcd5e8.jpg";